// wsapi sends the TrialLimitCategory enum name; only this one reads badly split on word boundaries.
const CATEGORY_LABELS: Record<string, string> = {
	SiteLocationChildrenPerSite: "sub-locations per site"
};

const splitCategoryWords = (category: string): string => category.replace(/([a-z0-9])([A-Z])/g, "$1 $2").toLowerCase();

const trialLimitLabel = (category: string | null | undefined): string | null => {
	const trimmed = category?.trim();
	if (!trimmed) return null;
	return CATEGORY_LABELS[trimmed] ?? splitCategoryWords(trimmed);
};

export default trialLimitLabel;
